import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgOk({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="m17.353 10.195.82 2.123-4.522 1.713 6.257 2.773L21 19.637l-7.863-3.397L9.68 24l-1.117-2.883 2.96-6.28-4.696 1.782-.818-2.123 11.344-4.3Zm-2.3-6.281c1.214 3.149-.412 6.703-3.625 7.92-3.213 1.219-6.815-.353-8.026-3.502-1.211-3.149.407-6.702 3.62-7.92 3.213-1.217 6.816.353 8.03 3.502ZM7.834 2.52c-2.04.774-3.075 3.02-2.31 5.005.767 1.985 3.049 2.972 5.089 2.199 2.04-.773 3.077-3.018 2.31-5.005-.765-1.986-3.049-2.972-5.089-2.199Zm3.271 3.614a.412.412 0 0 1 .263.522l-.044.117-.074.16c-.171.341-.538.902-1.179 1.144-.543.206-1.104.113-1.482-.004l-.204-.07-.202-.087-.051-.026a.41.41 0 0 1-.155-.552.418.418 0 0 1 .551-.174l.091.043.14.054.186.057c.24.061.549.095.828-.01.345-.131.57-.444.691-.667l.073-.146.042-.1a.417.417 0 0 1 .526-.26ZM7.936 5.08a.627.627 0 0 1-.033 1.162.636.636 0 0 1-.82-.364.627.627 0 0 1 .367-.812.64.64 0 0 1 .485.014Zm2.72-.556a.627.627 0 0 1-.366.812.636.636 0 0 1-.819-.362.627.627 0 0 1 .365-.813.637.637 0 0 1 .82.363Z"
                    fill="#297A71"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
SvgOk.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgOk
